import * as z from 'zod/mini'
import { CatalogueItemKind, FeatureKey, PlanTier } from '../../types'

export const createCheckoutBody = z.object({
  kind: z.enum(CatalogueItemKind),
  /** Catalogue lookup key, e.g. `plan_growth_monthly`. */
  lookupKey: z.string().check(z.minLength(1)),
  /**
   * Add-ons: the desired total quantity (0 removes the add-on).
   * Credits: how many packs to buy. Ignored for plans.
   */
  quantity: z.optional(z.int().check(z.minimum(0), z.maximum(500))),
})
export type CreateCheckoutBody = z.infer<typeof createCheckoutBody>

/** `?sessionId=` - the Stripe Checkout session the browser came back from. */
export const verifyCheckoutSessionQuery = z.object({
  sessionId: z.string().check(z.minLength(1)),
})
export type VerifyCheckoutSessionQuery = z.infer<typeof verifyCheckoutSessionQuery>

/** Dev-only: force an account onto a tier without going through Stripe. `null` hands it back to Stripe. */
export const setManualTierBody = z.object({
  tier: z.nullish(z.enum(PlanTier)),
  /** Replaces the tier's limit for each feature named; the value is a limit, a flag, or `null` for unlimited. */
  overrides: z.optional(z.partialRecord(z.enum(FeatureKey), z.union([z.number(), z.boolean(), z.null()]))),
  note: z.optional(z.string()),
})
export type SetManualTierBody = z.infer<typeof setManualTierBody>

/** Dev-only: burn credits so testers can watch the balance move. */
export const consumeSmsCreditsBody = z.object({
  amount: z.optional(z.int().check(z.minimum(1), z.maximum(1000))),
})
export type ConsumeSmsCreditsBody = z.infer<typeof consumeSmsCreditsBody>
